import { Component, Input } from "@angular/core";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { RoleTypeCode } from "@common/ADAPT.Common.Model/organisation/role-type-code";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { Practitioner } from "@common/ADAPT.Common.Model/practitioner/practitioner";
import { INewPersonModel } from "../new-coach.interface";

@Component({
    selector: "adapt-new-coach-confirmation",
    templateUrl: "./new-coach-confirmation.component.html",
    styleUrl: "./new-coach-confirmation.component.css",
    standalone: false,
})
export class NewCoachConfirmationComponent {
    @Input() public person?: Person;
    @Input() public temporaryPerson?: INewPersonModel;
    @Input() public practitioner!: Practitioner;
    @Input() public createdOrganisation?: Organisation;
    @Input() public joinOrganisation?: Organisation;
    @Input() public coachRoleTypeCodes!: Set<RoleTypeCode>;
    @Input() public completed!: boolean;

    public get coachRoles() {
        return Array.from(this.coachRoleTypeCodes)
            .map((c) => this.getCoachRoleTypeCodeLabel(c))
            .join(", ");
    }

    private getCoachRoleTypeCodeLabel(code: RoleTypeCode) {
        switch (code) {
            case RoleTypeCode.Coach:
                return "Adapt Build Coach";
            case RoleTypeCode.OwnerMentor:
                return "Adapt Design Coach";
            default:
                return "Unknown";
        }
    }
}
